import React, { useState } from "react";
import PropTypes from "prop-types";

// Open-ended feedback, in the page rather than in the site-wide popup: that one
// is desktop only and its endpoint requires a signed in user, which rules out
// almost everyone this page is built to reach.
//
// The prompt asks the thing actually worth knowing - whether this is worth
// building for another language or level - rather than "how are we doing".
export default function FeedbackForm({ feedbackUrl, onClose }) {
  const [message, setMessage] = useState("");
  const [email, setEmail] = useState("");
  const [website, setWebsite] = useState("");
  const [state, setState] = useState("idle");

  const submit = (event) => {
    event.preventDefault();
    if (state === "sending" || !message.trim()) return;

    setState("sending");
    const token = document.querySelector("meta[name=\"csrf-token\"]");

    fetch(feedbackUrl, {
      body: JSON.stringify({ email, message, website }),
      credentials: "same-origin",
      headers: {
        "Content-Type": "application/json",
        "X-CSRF-Token": token ? token.getAttribute("content") : "",
      },
      method: "POST",
    })
      .then((response) => setState(response.ok ? "sent" : "error"))
      .catch(() => setState("error"));
  };

  return (
    <div className="ir-modal-backdrop" onClick={onClose} role="presentation">
      <div
        aria-label="Send feedback"
        aria-modal="true"
        className="ir-modal"
        onClick={(event) => event.stopPropagation()}
        role="dialog"
      >
        <div className="ir-modal-head">
          <h2 className="ir-modal-title">What would make this better?</h2>
          <button aria-label="Close" className="ir-modal-close" onClick={onClose} type="button">&times;</button>
        </div>

        {state === "sent" ? (
          <div className="ir-modal-body">
            <p className="ir-modal-saved">Thanks &mdash; we read every one of these.</p>
            <div className="ir-modal-actions">
              <button className="ir-modal-btn" onClick={onClose} type="button">Back to the music</button>
            </div>
          </div>
        ) : (
          <form className="ir-modal-body" onSubmit={submit}>
            <label className="ir-modal-label" htmlFor="ir-feedback-message">
              Which language or level should we do next?
            </label>
            <textarea
              autoFocus
              className="ir-modal-input"
              id="ir-feedback-message"
              onChange={(event) => setMessage(event.target.value)}
              placeholder="B1 Portuguese, more genres, the vocals are hard to make out on the fast ones&hellip;"
              rows={4}
              value={message}
            />

            <label className="ir-modal-label" htmlFor="ir-feedback-email">
              Email
              <span className="ir-modal-hint">Optional, only so we can reply</span>
            </label>
            <input
              className="ir-modal-input"
              id="ir-feedback-email"
              onChange={(event) => setEmail(event.target.value)}
              type="email"
              value={email}
            />

            {/* Hidden from people, irresistible to bots. */}
            <input
              aria-hidden="true"
              autoComplete="off"
              className="ir-hp"
              onChange={(event) => setWebsite(event.target.value)}
              tabIndex={-1}
              value={website}
            />

            {state === "error" && <p className="ir-modal-error">That didn&apos;t send. Try again?</p>}

            <div className="ir-modal-actions">
              <button className="ir-modal-btn-ghost" onClick={onClose} type="button">Cancel</button>
              <button className="ir-modal-btn" disabled={state === "sending" || !message.trim()} type="submit">
                {state === "sending" ? "Sending…" : "Send"}
              </button>
            </div>
          </form>
        )}
      </div>
    </div>
  );
}

FeedbackForm.propTypes = {
  feedbackUrl: PropTypes.string.isRequired,
  onClose: PropTypes.func.isRequired,
};
